import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, filter, map, of, startWith, tap } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
 clicked: boolean = false;
 clickedResource: boolean = false;
 clickedThird: boolean = false;
 currentUrl$: Observable<string> = of();

 constructor(private router: Router){
  this.currentUrl$ = this.router.events
    .pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => event as NavigationEnd),
      startWith(new NavigationEnd(0, this.router.url, this.router.url)),
      map((event) => event.url),
      tap((url) => {
            if(url.includes('resources') || url.includes('multi-value-physical-table') || url === "/resource-relationships" || url === "/lookups") {
              this.clickedResource = true;
            } else {
              this.clickedResource = false;
            }
      })
    );
 }

 showClicked(){
  this.clicked = !this.clicked;
 }

 showResourceClicked(){
  this.clickedResource = !this.clickedResource;
 }

 showClickedThird(){
  this.clickedThird = !this.clickedThird;
 }

}
